export default {
  route: {
    home: 'Inicio',
    dashboard: 'Dashboard',
    users: 'Usuarios',
    clubs: 'Clubs',
    teams: 'Equipos',
    categories: 'Categorías',
    players: 'Jugadores',
    managers: 'Managers',
    positions: 'Posiciones',
    activity: 'Actividad',
    coaches: 'Entrenadores',
    documents: 'Documentos'
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard'
  },

  auth: {
    login: {
      email: 'Correo electrónico',
      password: 'Contraseña',
      logIn: 'Iniciar sesión',
      forgotPassword: '¿Has olvidado tu contraseña?'
    },

    passwordReset: {
      email: 'Correo electrónico',
      sendPasswordReset: 'Enviar correo electrónico para restablecer la contraseña',
      cancel: 'Cancelar'
    },

    emailUnverified: {
      pleaseConfirmYourEmailAt: 'Por favor, confirme su correo electrónico en',
      toContinue: ' para continuar.',
      resendEmailConfirmation: 'Reenviar correo electrónico de confirmación',
      signInWithAnotherAccount: 'Iniciar sesión con otra cuenta'
    },

    registerManager: {
      email: 'Correo electrónico',
      password: 'Contraseña',
      name: 'Nombre',
      lastName: 'Apellidos',
      phone: 'Número de teléfono',
      createAccount: 'Crear cuenta',
      accept: 'Aceptar',
      termnsConditions: 'Terminos y condiciones de uso',
      privacyPolicy: 'Política de privacidad',
      cancel: 'Cancelar'
    }
  },

  entities: {
    user: { singular: 'Usuario', plural: 'Usuarios' },
    club: {
      singular: 'Club', plural: 'Clubs',
      prop: {
        name: 'Nombre',
        emailManager: 'Email manager',
        statusManager: 'Estado manager',
        logo: 'Logo'
      }
    },
    team: {
      singular: 'Equipo', plural: 'Equipos', numberOfTeams: "Número de equipos",
      exportTeamAsPdf: 'Exportar pdf de equipo ',
      prop: {
        name: 'Nombre',
        category: 'Categoría',
        locality: 'Localidad',
        logo: 'Logo',
        country: 'Ciudad',
        web: 'Web'
      }
    },
    category: { singular: 'Categoría', plural: 'Categorías' },
    player: {
      singular: 'Jugador', plural: 'Jugadores',
      numberOfPlayers: "Nº jugadores",
      importPlayers: 'Importar jugadores',
      exportPlayers: 'Expotar jugadores',
      prop: {
        namePublic: 'Nombre deportivo',
        name: 'Nombre',
        lastName: 'Apellidos',
        dni: 'Dni/Nie/Pasaporte',
        email: 'Email',
        dorsal: 'Dorsal',
        phone: 'Teléfono',
        position: 'Posición',
        picture: 'Foto',
        birthdate: 'Fecha de nacimiento'
      }
    },
    coach: {
      singular: 'Entrenador', plural: 'Entrenadores',
      numberOfCoaches: "Nº entrenadores",
      importPlayers: 'Importar entrenador',
      exportCoachesAsPdf: 'Exportar pdf de entrenadores',
      prop: {
        name: 'Nombre',
        lastName: 'Apellidos',
        dni: 'Dni/Nie/Pasaporte',
        email: 'Email',
        birthdate: 'Fecha de nacimiento',
        phone: 'Teléfono',
        picture: 'Foto',
      }
    },
    teamManager: {
      singular: 'Delegado de equipo', plural: 'Delegados de equipo',
      numberOfTeamManager: "Nº delegados de equipo",
      exportTeamManagerAsPdf: 'Exportar pdf de delegados de equipo',
      prop: {
        name: 'Nombre',
        lastName: 'Apellidos',
        dni: 'Dni/Nie/Pasaporte',
        email: 'Email',
        birthdate: 'Fecha de nacimiento',
        phone: 'Teléfono',
        picture: 'Foto',
      }
    },
    manager: {
      singular: 'Manager', plural: 'Managers',
      prop: {
        name: 'Nombre',
        lastName: 'Apellidos',
        email: 'Email',
        phone: 'Teléfono'
      }
    },

    fieldManager: {
      singular: 'Delegado de campo', plural: 'Delegados de campo',
      prop: {
        name: 'Nombre',
        lastName: 'Apellidos',
        email: 'Email',
        phone: 'Teléfono'
      }
    },

    referee: {
      singular: 'Arbitro', plural: 'Arbitros',
      prop: {
        name: 'Nombre',
        lastName: 'Apellidos',
        email: 'Email',
        phone: 'Teléfono'
      }
    },
    position: { singular: 'Posición', plural: 'Posiciones' },
    document: { singular: 'Documento', plural: 'Documentos', prop: { name: 'Nombre', document: 'Documento' } },
    tournament: {
      singular: 'Tournament', plural: 'Tournaments',
      settingGroups: { title: 'Configuración de grupos', description: 'Arrastra el nombre del equipo al grupo que le corresponde' },
      group: 'Grupo',
      prop: {
        name: 'Nombre',
        category: 'Categoría',
        locality: 'Localidad',
        logo: 'Logo',
        country: 'Ciudad',
        web: 'Web'
      }
    }
  },

  notification: {
    savedSuccessfully: 'guardado con éxito!',
    deletedSuccessfully: 'eliminado con éxito!',
    invitationHasSendSuccessfully: 'Invitación enviada con éxito!'
  },

  confirm: {
    areYouSureCloseDialog: '¿Estás seguro de que quieres cerrar?'
  },

  table: {
    search: 'Buscar',
    add: 'Crear',
    addProperty: 'Agregar property',
    setting: 'Configurar',
    details: 'Detalles',
    edit: 'Editar',
    delete: 'Eliminar',
    sendInvitation: 'Enviar invitación',
    cancel: 'Cancel',
    export: 'Exportar',
    exportAsPdf: 'Exportar como pdf',
    import: 'Importar',
    history: 'Historial',
    actions: 'Acciones',
    confirm: 'Confirmar',
    areYouSure: '¿Estás seguro?',
    status: 'Status',
    yes: 'Si',
    no: 'No'
  },

  status: {
    modifiedAt: 'Modificado',
    created: 'Creado',
  },

  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export selected items',
    placeholder: 'Please enter the file name(default excel-list)'
  },

  tagsView: {
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },

  register: {
    email: 'Email',
    password: 'Contraseña',
    name: 'Nombre',
    lastName: 'Apellidos',
    phone: 'Número de teléfono',
    createAccount: 'Crear cuenta',
    accept: 'Accept',
    termnsConditions: 'Términos y condiciones',
    privacyPolicy: 'Política de privacidad',
    cancel: 'Cancelar'
  },

  validators: {
    isRequired: 'es obligatorio',
    lenghtMustBeLeast: 'la longitud debe ser como mínimo de',
    lenghtMustBeMax: 'la longitud debe ser como máximo de',
    valueShouldInteger: 'Introduce un número entero',
    valueIsRequired: 'Campo obligatorio',
    mustBeEmail: 'introduce un email correcto',
    shouldBeNumber: 'debería ser un número',
    mustBeAtLeast: ' debe ser al menos',
    mustBeAMaxOf: 'debe ser de un máximo de',
    valueSize: 'Deber rellenar al menos ',
    size: 'Tamaño'
  }
}



// WEBPACK FOOTER //
// ./src/lang/es.js